import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Avatar from '@material-ui/core/Avatar';
import InsertPhoto from '@material-ui/icons/InsertPhoto';

import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class Machine extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/xef/machines/' + this.props.info.id);
    };

    render() {
        const { info, active, last } = this.props;
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <Avatar className={'avatar margin_right_12 bg_bluish'}>
                    {info && info.foto && (
                        <img
                            src={info.foto}
                            alt="Preview"
                            style={{ width: 40 }}
                            onClick={this.openAvatarDialog}
                        />
                    )}
                    {(!info || !info.foto) && (
                        <InsertPhoto style={{ fontSize: 32 }} onClick={this.openAvatarDialog} />
                    )}
                </Avatar>
                <div
                    className={classNames(
                        'flex_full_row align_center',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{info.nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

Machine.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(Machine);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/machines/Machine.js